import React from "react";
import styled, { css } from "styled-components";
import { Carousel, Text } from 'src/components/Common';
import ReactSoldierImage from '/src/assets/soldiers/react_soldier.svg';
import NodeSoldierImage from '/src/assets/soldiers/node_soldier.svg';
import VueSoldierImage from '/src/assets/soldiers/vue_soldier.svg';
import PythonSoldierImage from '/src/assets/soldiers/python_soldier.svg';
import HtmlSoldierImage from '/src/assets/soldiers/html_soldier.svg';
import ReactCircleImage from '/src/assets/soldiers/Circle/react_circle_soldier.svg';
import VueCircleImage from '/src/assets/soldiers/Circle/vue_circle_soldier.svg';
import NodeCircleImage from '/src/assets/soldiers/Circle/node_circle_soldier.svg';
import PythonCircleImage from '/src/assets/soldiers/Circle/python_circle_soldier.svg';
import HtmlCircleImage from '/src/assets/soldiers/Circle/html_circle_soldier.svg';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { only } from 'styled-breakpoints';
import CarouselItem from './CarouselItem';
import useMediaQuery from 'src/style/useMediaQuery';

const INDICATOR_DATA = {
  0: { icon: <ReactCircleImage />, text: 'react' },
  1: { icon: <VueCircleImage />, text: 'vue' },
  2: { icon: <NodeCircleImage />, text: 'node' },
  3: { icon: <PythonCircleImage />, text: 'python' },
  4: { icon: <HtmlCircleImage />, text: 'html and css' },
};

const SOLDIER_DATA = {
  VUE: { desktop: VueSoldierImage, mobile: VueCircleImage },
  REACT: { desktop: ReactSoldierImage, mobile: ReactCircleImage },
  NODE: { desktop: NodeSoldierImage, mobile: NodeCircleImage },
  PYTHON: { desktop: PythonSoldierImage, mobile: PythonCircleImage },
  HTML: { desktop: HtmlSoldierImage, mobile: HtmlCircleImage },
};

const Root = styled.section`
  text-align: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin: 100px 0;

  #carousel-side {
    top: calc(50% - 280px);
    transform: translate(0, calc(-50% + 200px));
  }

  ${only('mini')} {
    margin: -50px 0 50px 0;
  };

  ${only('mobile')} {
    margin: 80px 0;
  };
`;

const Indicator = styled.div`
  cursor: pointer;
  transition: all .2s;

  &:not(:last-child) {
    margin-right: 50px;
  }

  ${props => props.isSelected && css`
    transform: scale(1.05);
  `};

  &:hover {
    transform: scale(1.05);
  }
`;

const SoldierCircle = styled.div`
  width: 120px;

  ${only('mobile')} {
    width: 100px;
  };
`;

const TechSection = () => {
  const mediaQuery = useMediaQuery();

  const soldierKey = mediaQuery.isMini ? 'mobile' : 'desktop';

  const renderCustomIndicator = (onClickHandler, isSelected, index, label) => (
    <Indicator onClick={onClickHandler} isSelected={isSelected}>
      <SoldierCircle>
        {INDICATOR_DATA[index].icon}
      </SoldierCircle>
      <Text text={INDICATOR_DATA[index].text} isBold={isSelected} />
    </Indicator>
  );

  return (
    <Root>
      <Carousel
        centerSlidePercentage={100}
        renderCustomIndicator={!mediaQuery.isMini && renderCustomIndicator}
        arrowColor="sceondary"
      >
        <CarouselItem
          backgroundImage="/images/react_BG.svg"
          Soldier={SOLDIER_DATA.REACT[soldierKey]}
          header="react"
          description="react description"
        />
        <CarouselItem
          backgroundImage="/images/vue_BG.svg"
          Soldier={SOLDIER_DATA.VUE[soldierKey]}
          header="vue"
          description="vue description"
        />
        <CarouselItem
          backgroundImage="/images/node_BG.svg"
          Soldier={SOLDIER_DATA.NODE[soldierKey]}
          header="node"
          description="node description"
        />
        <CarouselItem
          backgroundImage="/images/python_BG.svg"
          Soldier={SOLDIER_DATA.PYTHON[soldierKey]}
          header="python"
          description="python description"
        />
        <CarouselItem
          backgroundImage="/images/html_BG.svg"
          Soldier={SOLDIER_DATA.HTML[soldierKey]}
          header="html and css"
          description="html and css description"
        />
      </Carousel>
    </Root>
  )
};

export default TechSection;
